var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('label',{staticClass:"template content-type",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.contentType))])])}
var staticRenderFns = []

export { render, staticRenderFns }